export default function SectionContentProgession(el) {
    const cardsWrapper = el.querySelectorAll('.section-content-progression__cards');
    const cards = el.querySelectorAll('.section-content-progression__card-wrapper');
    const progressBar = el.querySelector('.section-content-progression__progress-bar-inner');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                cards.forEach(card => card.classList.remove('active'));

                entry.target.classList.add('in-view');
                entry.target.classList.add('active');

                const cardRect = entry.target.getBoundingClientRect();
                const wrapperRect = cardsWrapper[0].getBoundingClientRect();
                const cardCenterY = cardRect.top + cardRect.height / 2 - wrapperRect.top;
                if (entry.target === cards[cards.length - 1]) {
                    progressBar.style.height = '100%';
                } else {
                    progressBar.style.height = `${cardCenterY}px`;
                }

                // observer.unobserve(entry.target);
            }
        });
    }, { threshold: 1 });

    cards.forEach(card => {
        observer.observe(card);
    });
}
